import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const postEquipamentos = async (
  token: string,
  meta_execucao_fisico_id: number,
  nome_especificacao: string,
  quantidade: number,
  valor_unidade: number,
  valor_total: number
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.post(
    `${API_URL}/equipamentos`,
    {
      meta_execucao_fisico_id,
      nome_especificacao,
      quantidade,
      valor_unidade,
      valor_total,
    },
    config
  );
  return response.data;
};
export default postEquipamentos;
